import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=68452d1f&"
import script from "./DialogComponent.vue?vue&type=script&lang=js&"
export * from "./DialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports